export default class BlobWithFilename {
    constructor(blob, filename) {
        this.blob = blob;
        this.filename = filename;
    }
}
